import $ from "jquery";

const slide = () => {
  const init = () => {
    slider();
  };

  const slider = () => {
    const el = {
      question: ".js-FaqQuestion",
      prev: ".js-FaqNavigationPrev",
      next: ".js-FaqNavigationNext",
      chatBox: ".js-Faq__Placeholder__ChatBox",
      chatBoxTitle: ".js-Faq__Placeholder__ChatBox__Title",
      chatBoxDescription: ".js-Faq__Placeholder__ChatBox__Description",
      faqList: ".js-FaqLists__Item",
    };

    const action = (thisEL) => {
      const to = $(thisEL).data("to");
      const title = $(thisEL).data("title");
      const description = $(thisEL).data("description");

      $(el.question).removeClass("Active");
      $(el.faqList).removeClass("Active");
      $(`#${to}`).addClass("Active");
      $(`#head-${to}`).addClass("Active");
      $(el.chatBox).addClass("Slide");

      setTimeout(() => {
        $(el.chatBoxTitle).text(title);
        $(el.chatBoxDescription).text(description);
        $(el.chatBox).removeClass("Slide");
      }, 500);
    };

    $(document).on("click", el.prev, function () {
      action($(this));
    });

    $(document).on("click", el.next, function () {
      action($(this));
    });
  };

  init();
};

try {
  slide();
} catch (error) {
  console.error(error);
}
